/**
 * The server sends additional xref information on properties from xrefs we just want categories to be a list of ids.
 *
 * @param {import('immutable').List} questions
 * @returns {import('immutable').List}
 */
export const sanitizeQuestions = (questions) => {
    return questions.map((question) => {
        return question.set(
            'questionCategories',
            question.get('questionCategories').map((qc) => {
                return qc.get('questionCategoryId');
            }),
        );
    });
};
